import { AxiosError } from "axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Skill } from "@/model";
import skillRepository from "@/repository/skillRepository";
import { intentQueryKeys } from "@/query/intent";
import { selectorQueryKeys } from "@/query/selector";
import { skillQueryKeys } from "./keys";


export const useDeleteSkill = (agentId: number, skillId?: number) => {
    const queryClient = useQueryClient();

    return useMutation<Skill, AxiosError>({
        mutationKey: ["skill", 'agent', agentId, "skill", skillId, "delete"],
        mutationFn: async () => {
            try {
                const { data } = await skillRepository.delete(agentId, skillId!);
                return data;
            } catch (e) {
                throw e;
            }
        },
        onSuccess: async () => {
            await queryClient.invalidateQueries({
                queryKey: skillQueryKeys.all(agentId)
            });
            await queryClient.invalidateQueries({
                queryKey: selectorQueryKeys.pageAll(agentId)
            });
            await queryClient.invalidateQueries({
                queryKey: intentQueryKeys.names(agentId),
                refetchType: "all"
            });
            await queryClient.invalidateQueries({
                queryKey: intentQueryKeys.intents(agentId, skillId)
            });
        }
    });
};
